import { useEffect, useState } from 'react'
import Icon from '../../components/icons.jsx'
import { getOperacaoTeam } from '../../db/api.js'
import OperacaoTaskList from './OperacaoTaskList.jsx'
import OperacaoPersonProfile from './OperacaoPersonProfile.jsx'
import PersonAvatar from './PersonAvatar.jsx'
import './operacao-equipes.css'

const METRICS = [
  { id: 'abertas', label: 'Abertas', due: 'all' },
  { id: 'atrasadas', label: 'Atrasadas', due: 'atrasadas' },
  { id: 'hoje', label: 'Vencem hoje', due: 'hoje', tip: 'Prazos de hoje que ainda não venceram.' },
  { id: 'proximas', label: 'Próximos 7 dias', due: 'proximas', tip: 'Inclui o restante de hoje e os próximos sete dias.' },
  { id: 'sem_prazo', label: 'Sem prazo', due: 'sem_prazo' },
]
const EMPTY = { source: '', project_id: '', commercial_pipeline: '', priority: '' }

export default function OperacaoEquipes({ data, query, onRefresh }) {
  const [filters, setFilters] = useState(EMPTY)
  const [search, setSearch] = useState('')
  const [result, setResult] = useState(null)
  const [error, setError] = useState(null)
  const [retry, setRetry] = useState(0)
  const [detail, setDetail] = useState(null)
  const [personId, setPersonId] = useState(null)
  const requestKey = JSON.stringify({ clientId: query.clientId, ...Object.fromEntries(Object.entries(filters).filter(([, value]) => value)) })
  const summary = result?.key === requestKey ? result : null
  useEffect(() => {
    let active = true
    setError(null)
    getOperacaoTeam(JSON.parse(requestKey)).then(value => {
      if (active) setResult({ ...value, key: requestKey })
    }).catch(e => { if (active) setError(e.message) })
    return () => { active = false }
  }, [requestKey, data, retry])

  const openTasks = (person, metric) => setDetail({
    ...filters, view: 'all', due: metric.due,
    assignee: person?.id || '', unassigned: !person,
  })
  const changeSource = source => setFilters(f => ({ ...f, source, project_id: '', commercial_pipeline: '' }))
  const origin = filters.project_id ? `project:${filters.project_id}` : filters.commercial_pipeline ? `commercial:${filters.commercial_pipeline}` : ''
  const origins = (result?.origins || []).filter(item => !filters.source || item.source === filters.source)
  const filteredPeople = summary?.people.filter(person => person.nome.toLocaleLowerCase('pt-BR').includes(search.trim().toLocaleLowerCase('pt-BR'))) || []
  const filterActive = search || Object.values(filters).some(Boolean)

  if (personId) return <OperacaoPersonProfile key={`${query.clientId}:${personId}`} personId={personId} data={data} query={query} onBack={() => setPersonId(null)} onRefresh={onRefresh} />
  if (detail) return <OperacaoTaskList data={data} query={query} kind="todas" contextFilters={detail}
    teamContext onBack={() => setDetail(null)} onRefresh={onRefresh} />

  return <section className="oe-workspace" aria-label="Distribuição de tarefas da equipe">
    <div className="ot-controls">
      <div className="ov-heading"><div><h2>Distribuição por pessoa</h2><p>Acompanhe os prazos e abra as tarefas clicando nos números.</p></div>
        {summary && !error && <span className="oe-summary">{summary.totals.abertas} tarefas abertas · {summary.people.length} pessoas</span>}
      </div>
      <div className="ot-filters">
        <label className="ot-search"><Icon n="search" s={14} /><input aria-label="Buscar pessoa" placeholder="Buscar pessoa" value={search} onChange={e => setSearch(e.target.value)} /></label>
        <label className="ot-select"><select aria-label="Origem das tarefas da equipe" value={filters.source} onChange={e => changeSource(e.target.value)}>
          <option value="">Todas as origens</option><option value="project">Projetos</option>
          {result?.includes_commercial && <option value="commercial">Comercial</option>}
        </select><Icon n="chevron_d" s={12} /></label>
        <label className="ot-select"><select aria-label="Projeto ou funil da equipe" value={origin} onChange={e => {
          const [source, id] = e.target.value.split(':')
          setFilters(f => ({ ...f, project_id: source === 'project' ? id : '', commercial_pipeline: source === 'commercial' ? id : '' }))
        }}><option value="">Projeto ou funil</option>
          {[['project', 'Projetos'], ['commercial', 'Funis comerciais']].map(([source, label]) => {
            const items = origins.filter(item => item.source === source)
            return items.length > 0 && <optgroup key={source} label={label}>{items.map(item => <option key={item.id} value={`${source}:${item.id}`}>{item.nome}</option>)}</optgroup>
          })}
        </select><Icon n="chevron_d" s={12} /></label>
        <label className="ot-select"><select aria-label="Prioridade das tarefas da equipe" value={filters.priority} onChange={e => setFilters(f => ({ ...f, priority: e.target.value }))}>
          <option value="">Todas as prioridades</option><option value="urgente">Urgente</option><option value="alta">Alta</option><option value="media">Média</option><option value="baixa">Baixa</option>
        </select><Icon n="chevron_d" s={12} /></label>
        {filterActive && <button type="button" className="ot-clear" onClick={() => { setFilters(EMPTY); setSearch('') }}>Limpar</button>}
      </div>
    </div>
    {error ? <div className="ov-empty" role="alert">{error}<button className="od-btn" onClick={() => setRetry(v => v + 1)}>Tentar novamente</button></div>
      : !summary ? <div className="ov-empty" role="status">Carregando equipe…</div> : <>
        <section className="oe-unassigned" aria-label="Tarefas sem responsável">
          <div className="oe-unassigned-label"><Icon n="users" s={18} /><div><strong>Sem responsável</strong><small>{summary.unassigned.abertas ? 'Tarefas que precisam ser distribuídas.' : 'Todas as tarefas deste recorte têm responsável.'}</small></div></div>
          <div className="oe-unassigned-counts">{METRICS.map(metric => <button key={metric.id} type="button" className={`oe-count ${metric.id}`} disabled={!summary.unassigned[metric.id]} onClick={() => openTasks(null, metric)} aria-label={`${metric.label}: ${summary.unassigned[metric.id]} tarefas sem responsável`} title={metric.tip}>
            <span>{metric.label}</span><strong>{summary.unassigned[metric.id]}</strong>
          </button>)}</div>
        </section>
        <div className="oe-table-wrap"><table className="oe-table" aria-label="Tarefas abertas por pessoa">
          <thead><tr><th scope="col">Pessoa</th>{METRICS.map(metric => <th key={metric.id} scope="col" title={metric.tip}>{metric.label}</th>)}</tr></thead>
          <tbody>{filteredPeople.length ? filteredPeople.map(person => <tr key={person.id}>
            <th scope="row"><button type="button" className="oe-person oe-person-link" onClick={() => setPersonId(person.id)} aria-label={`Ver perfil de ${person.nome}`}><PersonAvatar person={person} /><span>{person.nome}</span><Icon n="chevron_r" s={13} /></button></th>
            {METRICS.map(metric => <td key={metric.id}><button type="button" className={`oe-count ${metric.id}`} disabled={!person[metric.id]} onClick={() => openTasks(person, metric)} aria-label={`${metric.label} de ${person.nome}: ${person[metric.id]}`} title={metric.tip}>{person[metric.id]}</button></td>)}
          </tr>) : <tr><td colSpan={6}><div className="ov-empty">{search ? 'Nenhuma pessoa encontrada.' : 'Nenhuma pessoa disponível nesta conta.'}</div></td></tr>}</tbody>
        </table></div>
        <p className="oe-note">Situação atual de tarefas abertas; arquivadas e excluídas ficam fora. Uma tarefa com vários responsáveis aparece para cada pessoa e conta uma vez no total. Próximos 7 dias inclui hoje.</p>
      </>}
  </section>
}
